import { render, staticRenderFns } from "./SuccessAndError.vue?vue&type=template&id=1e3772c4&scoped=true&"
import script from "./SuccessAndError.vue?vue&type=script&lang=js&"
export * from "./SuccessAndError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3772c4",
  null
  
)

export default component.exports